export default {
  savePageAsDefault: 'Nastaviť aktuálnu stránku ako domovskú',
  resetDefaultPage: 'Obnoviť predvolené nastavenia',
  bugReport: 'Nahlásiť chybu',
};
